/**
 * Calculate scores by topic and priority
 * @param {Array} projectItems - Project items with scores
 * @param {Object} qualityItems - Quality items structure
 * @param {boolean} isLegacyMode - Whether in legacy mode
 * @param {Object} legacyPriorityMap - Legacy priority mapping
 * @returns {Object} Scores organized by topic and priority
 */
(function($) {
	function calculateScoresByTopicAndPriority(projectItems, qualityItems, isLegacyMode = false, legacyPriorityMap = null) {
		const scoresByTopicAndPriority = {};

		// Build a lookup for qualityItems by safeguardid and initialize scores structure
		const qualityLookup = {};
		Object.keys(qualityItems).forEach(category => {
			Object.keys(qualityItems[category]).forEach(topic => {
				if (!scoresByTopicAndPriority[topic]) {
					scoresByTopicAndPriority[topic] = {};
				}
				qualityItems[category][topic].forEach(item => {
					const safeguardId = item.safeguardid.S;
					let priorityTag;

					if (isLegacyMode && legacyPriorityMap && item.cccmapping && item.cccmapping.S) {
						const cccSafeguardId = item.cccmapping.S.trim();
						priorityTag = legacyPriorityMap[cccSafeguardId];
						
						// Log all CCC mapped safeguards and their priority tags
						// console.log(`[calculateScoresByTopicAndPriority] CCC Mapping:`, {
						// 	modernSafeguardId: safeguardId,
						// 	legacySafeguardId: cccSafeguardId, 
						// 	priorityTag: priorityTag,
						// 	fullLegacyPriorityMap: legacyPriorityMap
						// });

						if (!priorityTag) {
							// console.warn(`[calculateScoresByTopicAndPriority] Priority tag for CCC mapped safeguard '${cccSafeguardId}' not found in legacy map.`);
						}
					}
					
					// If no CCC mapping priority tag found or not in legacy mode, use the original priority tag
					if (!priorityTag) {
						priorityTag = item.safeguardprioritytag.S;
					}

					if (priorityTag) {
						const normalizedPriorityTag = WebAssessmentCharts.normalizePriorityTag(priorityTag, isLegacyMode);

						if (!qualityLookup[safeguardId]) {
							qualityLookup[safeguardId] = [];
						}
						qualityLookup[safeguardId].push({ priorityTag: normalizedPriorityTag, topic: topic });

						// Initialize score counters for each priority within a topic
						if (!scoresByTopicAndPriority[topic][normalizedPriorityTag]) {
							scoresByTopicAndPriority[topic][normalizedPriorityTag] = { totalScore: 0, count: 0, itemCount: 0 };
						}
						// Increment the count of items available for this priority in qualityItems
						scoresByTopicAndPriority[topic][normalizedPriorityTag].itemCount++;
					}
				});
			});
		});

		// Process projectItems (the answers) to calculate total scores and count of "Not Applicable" items
		projectItems.forEach(item => {
			const projectSafeguardId = item.safeguardid.S;
			const maturityscore = item.maturityscore;
			const policyStatus = item.policystatus ? parseInt(item.policystatus.N, 10) : null;

			if (qualityLookup[projectSafeguardId]) {
				qualityLookup[projectSafeguardId].forEach(qualityItem => {
					const { topic, priorityTag } = qualityItem;
					const stats = scoresByTopicAndPriority[topic][priorityTag];

					if (policyStatus === 1) {
						// This is a "Not Applicable" answer
						stats.naCount = (stats.naCount || 0) + 1;
					} else if (maturityscore !== null) {
						// This is any other answered, applicable question
						stats.totalScore += maturityscore;
						stats.answeredCount = (stats.answeredCount || 0) + 1;
					}
				});
			}
		});

		// Compute average scores for each topic and priority tag.
		// Unanswered questions are now correctly handled by using `itemCount` from qualityItems for the denominator.
		Object.keys(scoresByTopicAndPriority).forEach(topic => {
			let totalMaturityScore = 0;
			let numberOfLevels = 0;

			Object.keys(scoresByTopicAndPriority[topic]).forEach(priority => {
				const stats = scoresByTopicAndPriority[topic][priority];
				const { totalScore, itemCount } = stats;
				const naCount = stats.naCount || 0;

				// The denominator is the total number of questions minus those marked "Not Applicable"
				const denominator = itemCount - naCount;

				if (denominator > 0) {
					// totalScore is the sum of scores for answered & applicable items.
					// Unanswered items contribute 0 to totalScore implicitly.
					// The average is taken over all applicable items (answered or not).
					let averageScore = ((totalScore / denominator) * 5).toFixed(2);
					stats.averageScore = parseFloat(averageScore);

					// Accumulate scores for overall maturity calculation
					totalMaturityScore += stats.averageScore;
					numberOfLevels++;
				} else {
					stats.averageScore = 0;
				}
			});

			// Calculate overall maturity score for the topic
			let overallScore = numberOfLevels > 0 ? (totalMaturityScore / numberOfLevels).toFixed(2) : "0.00";
			scoresByTopicAndPriority[topic].overallMaturityScore = parseFloat(overallScore);
		});

		return scoresByTopicAndPriority;
	}

	// Export for use in other modules
	if (typeof module !== 'undefined' && module.exports) {
		module.exports = calculateScoresByTopicAndPriority;
	} else if (typeof window !== 'undefined') {
		window.calculateScoresByTopicAndPriority = calculateScoresByTopicAndPriority;
	}

})(jQuery);